import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

// For tefOne we must replace out "O2" with "o2" so that the ligature in the "Air" font
// kicks in and displays "o2" as the actual O" logo
const linkContentWithLigaturFix = (node: HTMLElement) => unsafeHTML(node.innerText.replaceAll('O2', 'o2'));

export const tooltipTemplate = (
  stylecontext: string,
  node: HTMLElement,
) => html`<one-popover cloak context="${stylecontext}" placement="bottom">
  <one-link as="span" color="prominent" strong>${linkContentWithLigaturFix(node)}</one-link>
    <div slot="content">
      ${unsafeHTML(node.title)}
    </div>
</one-popover>`;

export default tooltipTemplate;
